<script setup>
import AutomationKanbanMoveInput from './AutomationKanbanMoveInput.vue';

const props = defineProps({
  modelValue: {
    type: [Array, Object],
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue', 'input']);
</script>

<template>
  <AutomationKanbanMoveInput
    mode="funnel"
    :model-value="props.modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    @input="emit('input', $event)"
  />
</template>
